<style>
  .login {
    left: 18.8%;
    width: auto;
    position: absolute;
    bottom: 0;
  }
</style>
<div class="text-center">
  <img src="../../../assets/img/hemisphere-logo-no-tag.png" class="logo" alt="Hemisphere logo" />
</div>
<div class="inner cover">
  <form class="signup-form" [formGroup]="signupForm" autocomplete="off">
    <div id="carousel" class="carousel showmanymoveone slide" data-interval="false" data-wrap="false">
      <div class="carousel-inner">
        <div formGroupName="userData">

          <div class="carousel-item active">
            <div class="text-content">
              <h2 class="signup text-left" id="confirm-email">
                <span class="green-text counter">2.</span>Fantastic, can you confirm that for us?
              </h2>
              <div class="form-group clearfix">

                <div class="input-group">
                  <input aria-labelledby="confirm-email" #emailConfirmIn type="text" id="emailConfirm"
                    formControlName="emailConfirm" name="emailConfirm" class="form-control" placeholder="Confirm email"
                    (keydown)="onKeyDownFunction($event, signupForm.get('userData.emailConfirm'), 3)"
                    [readonly]="!inputEnabled">
                  @if (signupForm.get('userData.emailConfirm').invalid &&
                  signupForm.get('userData.emailConfirm').touched) {
                  <span class="input-group-addon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z" />
                        <path fill="#FF495C"
                          d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
                      </g>
                    </svg>
                  </span>
                  }
                </div>
                @if (showEmailError && signupForm.get('userData.emailConfirm').invalid) {
                <div role="alert" class="error-container">
                  <span class="error-message-large">Sorry, but your email doesn’t match</span>
                </div>
                }

                <button id='nextEmail' (click)="onConfirm(signupForm.get('userData.emailConfirm'), 'password')"
                  class="btn btn-outline-primary btn-outline pull-left confirm">
                  <span>Confirm</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g fill="none" fill-rule="evenodd">
                      <path d="M0 0h24v24H0z" />
                      <path fill="#FFF" d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div class="carousel-item">
            <div class="text-content">
              <h2 class="signup text-left" id="lets-pick">
                <span class="green-text counter">3.</span>Great, let’s pick a password…
              </h2>
              <div class="form-group clearfix">
                <div class="input-group">
                  <input aria-labelledby="lets-pick" [type]="showPasswordA ? 'text' : 'password'" id="password" formControlName="password"
                    name="password" class="form-control" placeholder="Type here"
                    (keydown)="onKeyDownFunction($event, signupForm.get('userData.password'), 4)"
                    [readonly]="!inputEnabled">
                  @if (signupForm.get('userData.password').invalid && signupForm.get('userData.password').touched) {
                  <span class="input-group-addon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z" />
                        <path fill="#FF495C"
                          d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
                      </g>
                    </svg>
                  </span>
                  }
                </div>
                @if (signupForm.get('userData.password').invalid && signupForm.get('userData.password').touched) {
                <div role="alert" class="error-container">
                  <span class="helper-message">Passwords must be at least 8 characters long and include at least 1
                    uppercase letter, 1 lowercase letter, 1 number and a special character.</span>
                </div>
                }
                <button id='nextPassword' (click)="onConfirm(signupForm.get('userData.password'), 'passwordConfirm')"
                  class="btn btn-outline-primary btn-outline pull-left confirm {{!signupForm.get('userData.password').valid?'disabled':''}}">
                  <span>Confirm</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g fill="none" fill-rule="evenodd">
                      <path d="M0 0h24v24H0z" />
                      <path fill="#FFF" d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                    </g>
                  </svg>
                </button>
                <a data-testid="signup-show-password" (click)="onShowPasswordA()"
                  class="small login-gray-text dot-underline show-password">{{showPasswordA ? 'Hide' : 'Show'}}
                  password</a>
              </div>
            </div>
          </div>

          <div class="carousel-item">
            <div class="text-content">
              <h2 class="signup text-left" id="confirm-password">
                <span class="green-text counter">4.</span>Fantastic, can you confirm that for us?
              </h2>
              <div class="form-group clearfix">
                <div class="input-group">
                  <input aria-labelledby="confirm-password" [type]="showPasswordC ? 'text' : 'password'" id="passwordConfirm"
                    formControlName="passwordConfirm" name="passwordConfirm" class="form-control"
                    placeholder="Type here"
                    (keydown)="onKeyDownFunction($event, signupForm.get('userData.passwordConfirm'), 5)"
                    [readonly]="!inputEnabled">
                  @if (signupForm.get('userData.passwordConfirm').invalid &&
                  signupForm.get('userData.passwordConfirm').touched) {
                  <span class="input-group-addon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z" />
                        <path fill="#FF495C"
                          d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
                      </g>
                    </svg>
                  </span>
                  }
                </div>
                @if (signupForm.get('userData.passwordConfirm').invalid &&
                signupForm.get('userData.passwordConfirm').touched) {
                <div role="alert" class="error-container">
                  <span class="error-message-large">Sorry, but your password doesn’t match</span>
                </div>
                }
                <button id='nextPassword1'
                  (click)="onConfirm(signupForm.get('userData.passwordConfirm'), 'invitationCode')"
                  class="btn btn-outline-primary btn-outline pull-left confirm {{!signupForm.get('userData.passwordConfirm').valid?'disabled':''}}">
                  <span>Confirm</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g fill="none" fill-rule="evenodd">
                      <path d="M0 0h24v24H0z" />
                      <path fill="#FFF" d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                    </g>
                  </svg>
                </button>
                <a data-testid="signup-show-password-confirm" (click)="onShowPasswordC()"
                  class="small login-gray-text dot-underline show-password">{{showPasswordC ? 'Hide' : 'Show'}}
                  password</a>
              </div>
            </div>
          </div>

          <div class="carousel-item">
            <div class="text-content">
              <h2 class="signup text-left" id="enter-code">
                <span class="green-text counter">5.</span>Enter your invitation code.
              </h2>
              <div class="form-group clearfix">
                <div class="input-group">

                  @if (prepopulated) {
                  <div class="prepopulated"><img src="../../assets/img/correct.svg" /></div>
                  }

                  <input aria-labelledby="enter-code" #activationCode type="text" id="invitationCode"
                    formControlName="invitationCode" name="invitationCode" class="form-control" placeholder="Type here"
                    (keydown)="onKeyDownFunction($event, signupForm.get('userData.invitationCode'), 6)"
                    [readonly]="!inputEnabled" autocapitalize="none">
                  @if (!signupForm.get('userData.invitationCode').pristine &&
                  (!signupForm.get('userData.invitationCode').valid)) {
                  <span class="input-group-addon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z" />
                        <path fill="#FF495C"
                          d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
                      </g>
                    </svg>
                  </span>
                  }
                </div>
                <div class="info-container">
                  @if (prepopulated) {
                  <span class="helper-message">Your invitation code has been pre-populated.</span>
                  }
                  @if (!prepopulated) {
                  <span class="helper-message">If you do not have an invitation code, please
                    contact your HR team</span>
                  }
                </div>
                <label class="container">I acknowledge that I have read and agree to the Hemisphere <a
                    class="privacy-link" href="https://www.raretechnology.com/privacy-policy/" target="_blank">Privacy
                    Policy</a>
                  <input tabindex="0" type="checkbox" id="privacyPolicy" formControlName="privacyPolicy"
                    name="privacyPolicy" (click)="onPrivacy()" (keypress)="onPrivacy()" />
                  <span class="checkmark"></span>

                </label>
                <button id='signUP' (click)="onSignup()" [disabled]="submitting"
                  class="btn btn-outline-primary btn-outline pull-left confirm {{(!signupForm.valid && signupForm.touched) || submitting?'disabled':''}}">
                  <span>Register</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g fill="none" fill-rule="evenodd">
                      <path d="M0 0h24v24H0z" />
                      <path fill="#FFF" d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (currentIndex > 1) {
      <button class="carousel-control-prev" (click)="onBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="#555A69" fill-rule="evenodd" d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8z" />
        </svg>
        <span>Go back</span>
      </button>
      }

      @if (currentIndex === 1) {
      <button class="carousel-control-prev" (click)="goBackToEmail()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="#555A69" fill-rule="evenodd" d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8z" />
        </svg>
        <span>Go back</span>
      </button>
      }

      <!--<span class="small login-gray-text login"><a [routerLink]="['/signin']" class="dot-underline login-gray-text">Log in</a> an exist account</span>-->
    </div>
  </form>
</div>
<app-footer></app-footer>